import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

interface ToolbarProps {
  uid: string;
}

const CustomToolbar: React.FC<ToolbarProps> = ({ uid }) => (
  <div id={`toolbar${uid}`}>
    <select className="ql-size" defaultValue="medium">
      <option value="small">Small</option>
      <option value="medium">Medium</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <select className="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="orange"></option>
      <option value="violet"></option>
      <option value="#d0d1d2"></option>
      <option selected></option>
    </select>
    <select className="ql-background"></select>
    <button className="ql-link"></button>
    <button className="ql-image"></button>
  </div>
);

const SimpleToolbar: React.FC<ToolbarProps> = ({ uid }) => (
  <div id={`toolbar${uid}`}>
    <select className="ql-size" defaultValue="medium">
      <option value="small">Small</option>
      <option value="medium">Medium</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <select className="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="orange"></option>
      <option value="violet"></option>
      <option value="#d0d1d2"></option>
      <option selected></option>
    </select>

  </div>
);

const BlankToolbar: React.FC<ToolbarProps> = ({ uid }) => (
  <div id={`toolbar${uid}`} style={{ height: 0, borderWidth: 0 }}></div>
);

interface MyEditorProps {
  value: string;
  readOnly?: boolean;
  disableToolbar?: boolean;
  width?: string | number;
  onTextChange?: (text: string) => void;
  onChange?: (value: string) => void;
  noImage?: boolean;
  uid?: string;
}

function MyEditor({
  value, readOnly, disableToolbar, width,
  onTextChange = () => { }, onChange = undefined, noImage = false,
  uid = "",
}: MyEditorProps) {
  const modules = {
    toolbar: {
      container: `#toolbar${uid ?? ""}`,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "align",
    "color",
    "background",
    "image",
  ];

  const handleText = (value: string, editor: any) => {
    const textvalue = editor.getText();
    // const htmlValue = editor.getHTML();
    onTextChange?.(textvalue);
    onChange?.(value);
  };

  return (
    <div style={{ maxWidth: width }}>
      {disableToolbar ? <BlankToolbar uid={uid ?? ""} /> : (noImage) ? <SimpleToolbar uid={uid ?? ""} /> : <CustomToolbar uid={uid ?? ""} />}
      <ReactQuill
        style={{ width: "100%", borderWidth: 0 }}
        modules={modules}
        formats={formats}
        value={value}
        onChange={(value, delta, source, editor) => {
          handleText(value, editor);
        }}
        readOnly={readOnly}
      />
    </div>
  );
}

export default MyEditor;
